/* ol-b2c-sticky-recap.js — Barre sticky recap page reservation
   Sync depuis reservation + dates + services. Cache quand form section visible. */

(function () {
  'use strict';

  const sticky = document.querySelector('[data-sticky-recap]');
  if (!sticky) return;

  const reservRoot = document.querySelector('[data-ol-b2c-reservation]');
  const datesRoot = document.querySelector('[data-ol-b2c-dates]');
  const servicesRoot = document.querySelector('[data-ol-b2c-services]');
  const formRoot = document.querySelector('[data-ol-b2c-form]');

  const metaEl = sticky.querySelector('[data-sticky-meta]');
  const totalEl = sticky.querySelector('[data-sticky-total]');
  const cta = sticky.querySelector('[data-sticky-cta]');

  const MONTHS_SHORT = ['jan.','fév.','mars','avr.','mai','juin','juil.','août','sept.','oct.','nov.','déc.'];
  const humanShort = (s) => { const d = parseISO(s); return `${pad(d.getDate())} ${MONTHS_SHORT[d.getMonth()]}`; };
  const humanShortY = (s) => { const d = parseISO(s); return `${pad(d.getDate())} ${MONTHS_SHORT[d.getMonth()]} ${d.getFullYear()}`; };

  const housePriceCents = reservRoot ? parseInt(reservRoot.dataset.housePriceCents || '0', 10) : 0;
  const housePriceEuros = Math.round(housePriceCents / 100);

  let priceVariations = [];
  try {
    priceVariations = JSON.parse(reservRoot ? reservRoot.dataset.priceVariations || '[]' : '[]');
  } catch (e) {}

  const pad = (n) => String(n).padStart(2, '0');
  const parseISO = (s) => { const [y,m,d] = s.split('-').map(Number); return new Date(y, m-1, d); };
  const nightsBetween = (a, b) => Math.max(0, Math.round((parseISO(b) - parseISO(a)) / (1000*60*60*24)));

  function computePriceForDate(dateIso) {
    if (housePriceEuros <= 0) return 0;
    let price = housePriceEuros;
    for (const v of priceVariations) {
      if (!v || !v.start || !v.end) continue;
      if (dateIso >= v.start && dateIso <= v.end) {
        const val = Number(v.value) || 0;
        const type = (v.type || '').toLowerCase();
        if (type.includes('pourc') || type.includes('%')) price = price * (1 + val / 100);
        else if (type.includes('fixe')) price = price + val;
      }
    }
    return Math.round(price);
  }

  function iterateDates(startIso, endIso) {
    const out = [];
    const cur = parseISO(startIso);
    const end = parseISO(endIso);
    while (cur < end) {
      out.push(`${cur.getFullYear()}-${pad(cur.getMonth()+1)}-${pad(cur.getDate())}`);
      cur.setDate(cur.getDate() + 1);
    }
    return out;
  }

  function readPax() {
    if (!reservRoot) return 1;
    const el = reservRoot.querySelector('[data-pax-value]');
    return el ? (parseInt(el.textContent || '1', 10) || 1) : 1;
  }

  let hasDates = false;
  let formIsVisible = false;

  function applyVisibility() {
    if (hasDates && !formIsVisible) show();
    else hide();
  }

  function update() {
    // Dates
    const selected = datesRoot ? Array.from(datesRoot.querySelectorAll('.ol-b2c-reservation__day--selected')) : [];
    const isoList = selected.map(el => el.dataset.iso).filter(Boolean).sort();
    const checkIn = isoList[0];
    const checkOut = isoList[isoList.length - 1];

    let nights = 0, total = 0;
    hasDates = false;
    if (checkIn && checkOut && checkIn !== checkOut) {
      nights = nightsBetween(checkIn, checkOut);
      for (const iso of iterateDates(checkIn, checkOut)) {
        total += computePriceForDate(iso);
      }
      hasDates = true;
    }
    applyVisibility();

    const pax = readPax();
    let servicesCount = 0;
    if (servicesRoot) servicesCount = servicesRoot.querySelectorAll('[data-service]:checked').length;

    // Construction meta string sans espace parasite
    const parts = [];
    if (hasDates) parts.push(`${humanShort(checkIn)} — ${humanShortY(checkOut)}`);
    parts.push(`${nights} nuit${nights > 1 ? 's' : ''}`);
    parts.push(`${pax} invité${pax > 1 ? 's' : ''}`);
    parts.push(`${servicesCount} service${servicesCount > 1 ? 's' : ''}`);
    if (metaEl) metaEl.textContent = parts.join(' · ');

    // Total
    if (totalEl) totalEl.textContent = total > 0 ? `${total.toLocaleString('fr-FR')} €` : '—';
  }

  // === Observers ===
  if (datesRoot) {
    const cal = datesRoot.querySelector('[data-calendar]');
    if (cal) new MutationObserver(update).observe(cal, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });
  }
  if (reservRoot) {
    const paxEl2 = reservRoot.querySelector('[data-pax-value]');
    if (paxEl2) new MutationObserver(update).observe(paxEl2, { childList: true, characterData: true, subtree: true });
  }
  if (servicesRoot) {
    servicesRoot.querySelectorAll('[data-service]').forEach(input => input.addEventListener('change', update));
  }

  // === Visibility ===
  function show() { sticky.removeAttribute('hidden'); }
  function hide() { sticky.setAttribute('hidden', ''); }

  if (formRoot && 'IntersectionObserver' in window) {
    const io = new IntersectionObserver((entries) => {
      entries.forEach(e => {
        formIsVisible = e.isIntersecting;
        applyVisibility();
      });
    }, { threshold: 0.15 });
    io.observe(formRoot);
  }

  // CTA scroll to form recap
  if (cta) cta.addEventListener('click', () => {
    if (formRoot) formRoot.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });

  // Initial : hidden tant qu'aucune date sélectionnée
  hide();
  update();
})();
